// MIT License
//
// Copyright (c) 2019 Virtru Corporation
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import { h, Component } from 'preact';

class EmailCode extends Component {
  constructor() {
    super();

    this.state = {
      code: '',
      error: false
    };

    this.handleActivateCode = this.handleActivateCode.bind(this);
    this.handleCodeEntry = this.handleCodeEntry.bind(this);
  }

  handleCodeEntry(e) {
    this.setState({ code: e.target.value, error: false });
  }

  async handleActivateCode(e) {
    e.preventDefault();
    const { code } = this.state;
    let res;
    try {
      // TODO: remove the `V-` replacement in favor of the SDK handling it
      res = await this.props.onActivateCode(code.replace(/[V-]/gi, ''));
    } catch (err) {
      /* ignore error */
      this.setState({ error: true });
    }

    return res;
  }

  render() {
    const { error } = this.state;
    return (
      <div className='virtru-auth-email-code'>
        <div className='virtru-auth-instruction-sub'>
          Your code has been sent. Please check your email and enter it below.
        </div>
        <form onSubmit={this.handleActivateCode} className={error ? 'virtru-auth-form-error' : ''}>
          <input onInput={this.handleCodeEntry} className='virtru-auth-email-code-input' />
          <div className='virtru-auth-error-msg'>&#9888; Code was invalid. Please check your code and try again.</div>
          <button className='virtru-auth-button virtru-auth-button-virtru'>Activate Code</button>
        </form>
      </div>
    );
  }
}

export default EmailCode;
